import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const DataExportWidget: WidgetRegistryEntry = {
  name: "DataExportWidget",
  configuration: () => import("./configuration").then((m) => m.DataExportWidgetConfiguration),
  component: () => import("./data-export-widget.component").then((m) => m.DataExportWidgetComponent)
};
